
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Table Tennis Tournament</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chess2021 section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Table Tennis Tournament<span>at G H Raisoni University, Amravati  </span></h2>
        </div>
        <!-- <p>Nagpur| September 03: G H Raisoni Sports and Cultural Foundation in association with Nagpur Archery Association, is organising ‘G H Raisoni Memorial Archery Tournament, 2023’ on 3rd September, 2023, at 8:30 am on the G H Raisoni Institute of Engineering and Technology campus.</p>
       <p>G H Raisoni Memorial Archery Tournament is open to participant’s age-group Under 9, Under 11, Under 14, Under 17, and Under 19 and open. The tournament offers certificates, medals and making it an enticing and rewarding experience for the participating archers. The aim of the event is to promote sportsmanship skills among young talents in the field of archery.</p>
        <p>The organizers have meticulously planned the event to ensure adherence to all necessary safety protocols,ensuring a secure environment for all participants and attendees. The Archery Tournament 2023 promises to be a thrilling display of skill and precision as talented archers from various regions participate in the competition.</p>
        <p>To register click the link below :- <a href="https://forms.gle/Qq8V9yxdaqA7Gvyd8">https://forms.gle/Qq8V9yxdaqA7Gvyd8</a></p> -->
        <p class="text-justify"> G H Raisoni University, Amravati, in collaboration with the Amravati District Table
            Tennis Association organized the G H Raisoni Memorial Table Tennis Tournament
            on September 17, 2023. The event commenced at 8:30 AM in the on the GHRU
            university campus. The tournament was graced by the presence of Dr. Dipti Ruikar
            and Mr. Khan Sir during the inaugural ceremony.</p>
        <p class="text-justify">
            A total of 80 players across various age categories, including under 12 years, under
            14 years, under 17 years, under 19 years, and Men&#39;s and Women&#39;s open categories,
            participated in this exciting day-long competition. The players displayed remarkable
            enthusiasm and dedication to the game.</p>
        <p class="text-justify">
            Winners were honored with cash prizes, trophies, and certificates by esteemed
            dignitaries. Additionally, all participants received certificates and participation medals
            to commemorate their involvement.</p>


        <h5 class="fw-bold">Result of this competition</h5>
        <div class="row row-cols-1 row-cols-md-3">

            <div class="col">

                <h6 >1) Midgate : </h6>
                <ul class="list-style list-style1">
                    <li>Winner - Rishit Dabhade</li>
                    <li>
                        Runner - Vidhan Kalkar</li>
                </ul>
                <h6 >2) Cadet :</h6>
                <ul class="list-style list-style1">
                    <li>Winner – Hanish Bohara</li>
                    <li>
                        Runner – Ishwari Dhawade</li>
                </ul>
                <h6 > 3) Sub Jr :</h6>
                <ul class="list-style list-style1">
                    <li>Winner - Rayan Borkar</li>
                    <li>
                        Runner – Ishwari Dhawade</li>
                </ul>

            </div>
            <div class="col">
                <h6 > 4) Junior :</h6>
                <ul class="list-style list-style1">
                    <li>Winner - Rayan Borkar</li>
                    <li>
                        Runner – Sarthak Puslekar</li>
                </ul>
                <h6 > 5) Youth : </h6>
                <ul class="list-style list-style1">
                    <li>Winner - Jayendra Ganorkar</li>
                    <li>
                        Runner – Sarthak Puslekar</li>
                </ul>
            </div>
            <div class="col">

                <h6 > 6) Mens : </h6>
                <ul class="list-style list-style1">
                    <li>Winner - Sarthk Tabhane</li>
                    <li>
                        Runner – Jayendra Ganorkar</li>
                </ul>
                <h6 > 7) Womens : </h6>
                <ul class="list-style list-style1">
                    <li>Winner – Ishwari Dhawade</li>
                    <li>
                        Runner – Anjali Deshmukh</li>
                </ul>
            </div>


        </div>

    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="row row-cols-1 row-cols-md-2">
            <!-- <div class="col">
                <div class="gall-ery">
                    <div class="widget_title inner-title gall-sys shadow-text-sm">
                        <h4 class="fw-bold">Media Coverage</h4>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                            <li class="col" data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/media-1.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/media-1.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/media-1.webp" alt="GHRSCF" title="GHRSCF"
                                        class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col" data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/media-2.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/media-2.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/media-2.webp" alt="GHRSCF" title="GHRSCF"
                                        class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col" data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/media-3.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/media-3.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/media-3.webp" alt="GHRSCF" title="GHRSCF"
                                        class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div> -->
            <div class="col">

                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Photos</h4>
                            </div>
                        </div>
                        <div class="col-md-5 text-end">
                            <a href="photogallery#tennis " target="_blank" class="cmn-white-button"><span>
                                    View More</span>
                            </a>
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-1.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-1.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-1.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-2.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-2.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-2.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-3.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-3.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-3.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>

                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-4.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-4.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-4.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-5.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-5.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-5.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>


                        </ul>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
